import { getAppLaunchParamsFx } from "../lib/getAppLaunchParamsFx/getAppLaunchParamsFx"
import { getUserAccessTokenFx } from "../lib/getUserAccessTokenFx/getUserAccessTokenFx"
import { IAppLaunchParams } from "./types"
import bridge from "@vkontakte/vk-bridge"
import { createEvent, createStore, sample } from "effector"
import { createGate } from "effector-react"
import { v4 as uuidv4 } from "uuid"

export const UserGate = createGate()
export const GetVKAccessTokenGate = createGate()

// Ключ для localStorage
const USER_HASH_STORAGE_KEY = "userHash"

const setIsStandAlone = createEvent<boolean>()
const setUserHash = createEvent<string>()

export const $isStandAlone = createStore<boolean | null>(null)
export const $userHash = createStore<string | null>(null)
  // При инициализации стора пытаемся получить хеш из localStorage
  .on(setUserHash, (_, hash) => hash)

export const $userId = createStore<string>("-1")
export const $isUserUseMobileApp = createStore<boolean | null>(null)
export const $appLaunchParams = createStore<IAppLaunchParams | null>(null)
export const $userAccessToken = createStore<string | null>(null)

// Функция для работы с localStorage
const getUserHashFromStorage = (): string | null => {
  if (typeof window !== "undefined") {
    return localStorage.getItem(USER_HASH_STORAGE_KEY)
  }
  return null
}

const saveUserHashToStorage = (hash: string): void => {
  if (typeof window !== "undefined") {
    localStorage.setItem(USER_HASH_STORAGE_KEY, hash)
  }
}

// При открытии UserGate сначала проверяем localStorage
sample({
  clock: UserGate.open,
  fn: () => {
    // Пытаемся получить сохраненный хеш
    const savedHash = getUserHashFromStorage()
    // Если есть - возвращаем его, иначе генерируем новый
    return savedHash || uuidv4()
  },
  target: setUserHash,
})

// При установке нового хеша сохраняем его в localStorage
sample({
  clock: setUserHash,
  fn: (hash) => {
    saveUserHashToStorage(hash)
    return hash
  },
  target: $userHash,
})

sample({
  clock: UserGate.open,
  fn: () => bridge.isStandalone() || bridge.isIframe(),
  target: setIsStandAlone,
})

sample({
  clock: setIsStandAlone,
  target: $isStandAlone,
})

sample({
  clock: UserGate.open,
  target: getAppLaunchParamsFx,
})

sample({
  clock: GetVKAccessTokenGate.open,
  fn: () => null,
  target: getUserAccessTokenFx,
})

sample({
  clock: getAppLaunchParamsFx.doneData,
  target: $appLaunchParams,
})
sample({
  clock: getAppLaunchParamsFx.doneData,
  fn: (params) => String(params.vk_user_id || -1),
  target: $userId,
})

sample({
  clock: getUserAccessTokenFx.doneData,
  target: $userAccessToken,
})

// sample({
//   clock: $appLaunchParams,
//   filter: (params) => !!params?.vk_user_id,
//   fn: (params) => params!.vk_user_id!,
//   target: $userId,
// })

sample({
  clock: $appLaunchParams,
  fn: (params) => params?.vk_platform !== "desktop_web",
  target: $isUserUseMobileApp,
})
